module.exports = __webpack_public_path__ + "static/together_bg3_1-da29cf132f3186a487b451dc0f5b8bdc.png";